
import BaseStore from 'models/BaseStore'

export default class DailyStore extends BaseStore {

  // アクセサ: 検索用キー値を取得
  static key(storeCode, floorCode, date) {
    if(storeCode instanceof Object) {
      floorCode = storeCode.floor_code
      date      = storeCode.date
      storeCode = storeCode.store_code
    }
    return storeCode + '/' + floorCode + '/' + date
  }
}
